import { Moment } from "moment";
import MDP from "../../MDP";
import { FFormChildMDP } from "../FFormMDP";

export default class FDateSelectRangeFieldMDP implements MDP {
  componentName: string = "FDateSelectRangeField";
  label: string;
  dataSelectorKey: string;
  rules: string;
  mandatory: boolean;
  parentMDP: FFormChildMDP;
  boundaryClass?: string;
  disabled: boolean;
  pastDaysDisabled: boolean;
  futureDaysDisabled: boolean;
  dateDisplayFormat: string;
  condition: boolean;
  readonly: boolean;
  minimumDate?: Moment;
  maximumDate?: Moment;
  onSelect?: (date: any) => void;
  constructor({
    parentMDP,
    dataSelectorKey,
    label,
    rules = "",
    mandatory = false,
    boundaryClass,
    disabled = false,
    pastDaysDisabled = false,
    futureDaysDisabled = false,
    dateDisplayFormat = "MMM DD, YYYY",
    condition = true,
    readonly = false,
    minimumDate,
    onSelect,
    maximumDate,
  }: {
    parentMDP: FFormChildMDP;
    dataSelectorKey: string;
    label: string;
    type?: string;
    rules?: string;
    mandatory?: boolean;
    boundaryClass?: string;
    disabled?: boolean;
    pastDaysDisabled?: boolean;
    futureDaysDisabled?: boolean;
    dateDisplayFormat?: string;
    condition?: boolean;
    readonly?: boolean;
    onSelect?: (date: any) => void;
    minimumDate?: Moment;
    maximumDate?: Moment;
  }) {
    this.parentMDP = parentMDP;
    this.dataSelectorKey = dataSelectorKey;
    this.label = label;
    this.rules = rules;
    this.mandatory = mandatory;
    this.boundaryClass = boundaryClass;
    this.disabled = disabled;
    this.pastDaysDisabled = pastDaysDisabled;
    this.futureDaysDisabled = futureDaysDisabled;
    this.dateDisplayFormat = dateDisplayFormat;
    this.condition = condition;
    this.readonly = readonly;
    this.onSelect = onSelect;
    this.minimumDate = minimumDate;
    this.maximumDate = maximumDate;
  }

  getRules() {
    const required = this.mandatory ? "required" : "";
    return `${required}|${this.rules}`;
  }

  getBoundaryClass() {
    return `${
      this.boundaryClass ? this.boundaryClass : this.parentMDP.boundaryClass
    } py-0 px-2`;
  }

  isDisabled() {
    return this.disabled || this.readonly;
  }

  getMetaData() {
    return {
      componentName: this.componentName,
      dataSelectorKey: this.dataSelectorKey,
      rules: this.getRules(),
      boundaryClass: this.getBoundaryClass(),
      condition: this.condition,
      props: {
        id: this.dataSelectorKey,
        label: this.label,
        outlined: this.parentMDP.outlined,
        dense: this.parentMDP.dense,
        disabled: this.isDisabled(),
        readonly: this.readonly,
        pastDaysDisabled: this.pastDaysDisabled,
        futureDaysDisabled: this.futureDaysDisabled,
        dateDisplayFormat: this.dateDisplayFormat,
        onSelect: this.onSelect,
        minimumDate: this.minimumDate,
        maximumDate: this.maximumDate,
      },
    };
  }
}
